import React from 'react';
import FinancialReportPage from './FinancialReportPage';

const InternetFinancialReportPage: React.FC = () => <FinancialReportPage category="internet" />;

export default InternetFinancialReportPage;
